export default __webpack_public_path__ + "ae23b74cd7e3e6a432b730cb0e88f31b.svg";